import { defineMessages } from 'utils/intl';

export default defineMessages({
  showMoreFilters: 'Pokaż filtry',
  showLessFilters: 'Schowaj filtry',
  availableNow: 'Dostępne w 24h',
});
